/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import { Box, Text } from '@towersystems/towersystems-design-system';

const DetailListItem = ({ label, detail }) => {
    return (
        <Box padding='small' display='flex' justifyContent='spaceBetween'>
            {label && (<Text weight='medium' size='small'>{label}</Text>)}
            <Text size='small'>{detail || '-'}</Text>
        </Box>
    );
};

export default DetailListItem;
